enum LockType {
    Order = 1,
    Procedure,
    Report,
    Label,
    Patient,
    Company,
    HealthInsurance,
    Radiologist,
    Technician,
    Invoice,
    Physician,
    Links,
    Urgency,
    Visit,
    Nomenclature,
}

export default LockType;
